<template>
  <section v-if="newUiEnabled" class="ui-form-section">
    <h3 class="ui-form-heading">
      <UiIcon v-if="icon" :fa="`fa ${icon}`" aria-hidden="true" />

      <slot name="title">{{ title }}</slot>

      <span v-if="optional" class="ui-attribute">({{ $t("optional") }})</span>
    </h3>

    <slot />
  </section>

  <div v-else class="form-section mb-4">
    <h6 class="form-section-header mb-3">
      <UiIcon v-if="icon" :fa="`fa ${icon} fa-fw me-2`" />

      <slot name="title">{{ title }}</slot>

      <small v-if="optional" class="text-muted fw-normal ms-1">({{ $t("optional") }})</small>
    </h6>

    <slot />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";

defineProps<{
  title?: string;
  icon?: string;
  optional?: boolean;
}>();

const { t: $t } = useI18n();

const newUiEnabled = useNewUiEnabled();
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.form-section-header {
  color: $primary;
  font-weight: 600;
  margin-bottom: 1rem;
}
</style>
